import { useSyncExternalStore } from 'react';

/** The current client org (QBO "client switcher"), persisted per browser. */
const KEY = 'outss.orgId';
const listeners = new Set<() => void>();

export function getOrgId(): string | null {
  return window.localStorage.getItem(KEY);
}

export function setOrgId(id: string | null): void {
  if (id === getOrgId()) return;
  if (id) window.localStorage.setItem(KEY, id);
  else window.localStorage.removeItem(KEY);
  listeners.forEach((l) => l());
}

export function useOrgId(): string | null {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    getOrgId,
    () => null,
  );
}
